import * as React from "react";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Icon1 from "../icons/Icon";
import Space from "../layout/Space";
import PrimaryButton from "../buttons/PrimaryButton";
import Row from "../layout/Row";
import Modal1 from "../modals/Modal1";
import { useState } from "react";
import SecondaryButton from "../buttons/SecondaryButton";
import WarningButton from "../buttons/WarningButton";
import deleteClient from "../api/delete/deleteClient";
import { getOrRefreshFirebaseToken } from "../config/getFirebaseToken";
import { useAppContext } from "../config/AppContext";
import updateDocDataFieldApi from "../api/database/updateDocDataFieldApi";
import TextField2 from "../textfields/TextField2";
import { Spin } from "antd";
import SmallSpinner from "../loading/SmallSpinner";

export default function PartnersAM({
  masterData,
  clientData,
  userData,
  actionModify,
  navigateWorkspace,
}) {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);

  const { appState, setAppState } = useAppContext();
  const prefix = appState.dev ? appState.dev_url : appState.prod_url;

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const [loadingDelete, setLoadingDelete] = useState(false);
  const [confirm_text, setConfirmText] = useState("");
  const handleDeleteClient = async () => {
    setLoadingDelete(true);
    setOpenDelete(false);
    let alert_clients = masterData.alerts?.clients || [];
    alert_clients = alert_clients.filter((client) => client !== clientData.id);
    await updateDocDataFieldApi(
      masterData.ref,
      "alerts.clients",
      alert_clients,
      prefix
    );
    const token = await getOrRefreshFirebaseToken();
    await deleteClient(masterData.id, clientData.id, token, prefix);
    navigateWorkspace("/partners");
    setLoadingDelete(false);
  };

  const [openDelete, setOpenDelete] = useState(false);

  return (
    <div>
      <Modal1 isOpen={openDelete} onClose={() => setOpenDelete(false)}>
        <div className=" flex flex-col bg-white rounded-xl p-4">
          <div className="text-h2">
            Voulez-vous vraiment supprimer cet élément ?
          </div>
          <div className="text-h3 text-shadow_50 my-4">
            Cette action est <span className="text-red-500">irréversible</span>.
          </div>
          <div className="text-h3 text-shadow_50 mb-4">
            Elle entraîne la suppression définitive de ces éléments.
          </div>
          <div className="text-h3 text-shadow_50">- Membres de l'équipe</div>
          <div className="text-h3 text-shadow_50 ">- Dossiers</div>
          <div className="text-h3 text-shadow_50 ">- Messages</div>
          <div className="text-h3 text-shadow_50 ">- Devis</div>
          <div className="text-h3 text-shadow_50 ">- Evènements</div>
          <div className="text-h3 text-shadow_50 my-4">
            Entrez CONFIRMER pour confirmer la suppression.
          </div>
          <TextField2
            label="CONFIRMER"
            value={confirm_text}
            onChange={(e) => setConfirmText(e.target.value)}
          ></TextField2>
          <Space y={20} />
          {!loadingDelete && (
            <div className="flex flex-row justify-end gap-2 ">
              <SecondaryButton onClick={() => setOpenDelete(false)}>
                Annuler
              </SecondaryButton>
              <WarningButton
                disabled={confirm_text != "CONFIRMER"}
                onClick={handleDeleteClient}
              >
                Supprimer
              </WarningButton>
            </div>
          )}
          {loadingDelete && <SmallSpinner></SmallSpinner>}
        </div>
      </Modal1>

      <PrimaryButton
        id="basic-button"
        aria-controls={open ? "basic-menu" : undefined}
        aria-haspopup="true"
        aria-expanded={open ? "true" : undefined}
        onClick={handleClick}
      >
        <Row x={10}>
          Actions <Icon1 icon_name="menu" fill="white"></Icon1>
        </Row>
      </PrimaryButton>
      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "200px", // Set the menu width
            backgroundColor: "white", // Set background to white
            borderRadius: "12px", // Round the corners
            boxShadow: "0px 4px 12px rgba(0, 0, 0, 0.3)", // Add shadow for better styling
            padding: "4px", // Add padding if needed
            pointerEvents: "auto", // Ensure the menu is interactive
          },
        }}
        MenuListProps={{
          "aria-labelledby": "basic-button",
          color: "black",
        }}
      >
        <MenuItem onClick={actionModify}>
          <div className="">
            <Icon1 icon_name="modify"></Icon1>
          </div>
          <Space x={2} />
          <div className="flex flex-grow flex-row-reverse text-h2">
            Modifier
          </div>
        </MenuItem>
        {userData.org_admin && (
          <MenuItem
            onClick={() => {
              setOpenDelete(true);
              handleClose();
            }}
          >
            <div className="">
              <Icon1 icon_name="delete"></Icon1>
            </div>
            <Space x={2} />
            <div className="flex flex-grow flex-row-reverse text-h2">
              Supprimer
            </div>
          </MenuItem>
        )}
      </Menu>
    </div>
  );
}
